var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-icon',{staticClass:"icon",style:({fontSize:'1.5em'}),attrs:{"backgroundColor":"#DDDDDD","color":"#999999","icon":"bars"}})}
var staticRenderFns = []

export { render, staticRenderFns }